module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('section', {
    staticClass: "rgBox"
  }, [_c('div', {
    staticClass: "rgs rgs1"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/c29.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rgTip2 fhc animated fadeInRight"
  }, [_vm._v(_vm._s(_vm.companys.telphone))])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "rgs",
    on: {
      "click": function($event) {
        return _vm.closeFade()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/c31.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "rgs",
    on: {
      "click": function($event) {
        return _vm.goTop()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/c32.png")
    }
  })])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.chatFade),
      expression: "chatFade"
    }],
    staticClass: "chatfade chatshow"
  }, [_c('div', {
    staticClass: "chatcontent fwc"
  }, [_c('p', [_vm._v("欢迎来到冰谷数字科技官网，有什么问题可以随时咨询哦！")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/images/c15.png")
    },
    on: {
      "click": function($event) {
        return _vm.closeFade()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "chataction fws"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.chatMsg),
      expression: "chatMsg"
    }],
    attrs: {
      "type": "text",
      "placeholder": "您可以直接在这里和我们联系",
      "value": ""
    },
    domProps: {
      "value": (_vm.chatMsg)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.upChat()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.chatMsg = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "chatbtn",
    on: {
      "click": function($event) {
        return _vm.upChat()
      }
    }
  }, [_vm._v("发 送")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rgs rgs2"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/c34.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "rgTip animated fadeInRight"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/c0.png")
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2fe37470","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chater/Chater.vue
// module id = 229
// module chunks = 10